import { PageableResponseWrapper, PageQueryParams } from '../../../domain/response-wrapper';
import { Role } from '../../../domain/Role';
import useAuth from '../../../hooks/useAuth';
import { useFetch } from '../../../hooks/useFetch';
import { usePagination } from '../../../hooks/usePagination';
import { Terminal } from '../models/terminal';

export interface TerminalFiltersQueryParams extends PageQueryParams {
  idMerchant?: string[];
  serialNumber?: string;
}

const initialParams: TerminalFiltersQueryParams = {
  page: 0,
  size: 5,
  idMerchant: [],
  serialNumber: undefined,
};

export const useTerminalsFilters = () => {
  const { user } = useAuth();

  const role = user?.roles.includes(Role.auditor) ? 'auditor' : 'branch-owner';

  const { queryParams, setParam, nextPage, prevPage, search, updateParams } = usePagination<TerminalFiltersQueryParams>(initialParams);
  const { data, error, loading } = useFetch<PageableResponseWrapper<Terminal>>(`/terminals-view/${role}`, queryParams);

  const resetFilters = () => {
    updateParams(initialParams);
  }

  return {
    data,
    error,
    loading,
    queryParams,
    setParam,
    nextPage,
    prevPage,
    search,
    resetFilters,
  };
};
